import alert from '@/plugins/alert'
import { Bus } from '@/plugins/api'
import { get, keyBy, rangeRight } from 'lodash'

export default {
  namespaced: true,
  state: {
    busData: {},
    count: 0,
    search: [],
    pageText: '',
    itemsPerPage: 10,
    busSearchParams: {},
    totalItems: 0,
    busesData: [],
    loading: false
  },
  actions: {
    searchBuses({ commit, state, dispatch }, query) {
      const busSearchParams = {
        _limit: state.itemsPerPage,
        ...query
      }
      commit('changeState', { busSearchParams })
      dispatch('requestPageSettings', {})
    },
    async requestPageSettings({ state, commit, dispatch }, { page, itemsPerPage }) {
      state.loading = true
      if (!page) page = 1
      if (!itemsPerPage) itemsPerPage = state.itemsPerPage
      if (state.busSearchParams) {
        const busSearchParams = {
          ...state.busSearchParams,
          _sort: 'name:ASC',
          _start: (page - 1) * itemsPerPage,
          _limit: itemsPerPage
        }
        const [totalItems, busesData] = await Promise.all([Bus.count(busSearchParams), Bus.search(busSearchParams)])
        if (totalItems > (page - 1) * itemsPerPage || page === 1) {
          commit('changeState', {
            busesData,
            totalItems,
            itemsPerPage,
            busSearchParams
          })

          const pageStart = (page - 1) * itemsPerPage + 1
          let pageStop = page * itemsPerPage
          pageStop = pageStop > totalItems || pageStop === -1 ? totalItems : pageStop
          const pageText = `${pageStart}-${pageStop} trên ${totalItems}`
          commit('setPageText', pageText)
        } else {
          var pages = rangeRight(1, page)
          for (let index = 0; index < pages; index++) {
            const selectedPage = pages[index]
            if (totalItems > (selectedPage - 1) * itemsPerPage) {
              dispatch('requestPageSettings', {})
              break
            }
          }
        }
      }
      state.loading = false
    },

    async fetchBuses({ commit }, params) {
      const busesData = await Bus.fetch({ ...params, _limit: -1 })
      commit('changeState', {
        busesData
      })
      return busesData
    },
    async countBuses({ commit }, params) {
      const buses = await Bus.count(params)
      commit('countBuses', buses)
    },
    async createBus({ commit, state }, busData) {
      try {
        const buses = await Bus.fetch({
          name: busData.name,
          _limit: 1
        })
        if (buses && buses.length) {
          alert.error('Tên tuyến đã tồn tại')
          return
        }
        const newBus = await Bus.create(busData)
        alert.success('Tạo tuyến mới thành công!')
        commit('changeState', {
          busesData: [newBus, ...state.busesData]
        })
      } catch (e) {
        alert.error(e)
      }
    },
    async updateBus({ commit, state }, { id, ...busData }) {
      commit('updateBus', await Bus.update(id, busData))
    },
    async removeBuses({ dispatch }, items = []) {
      for (let item of items) {
        await dispatch('removeBus', item.id)
      }
    },
    async updateBuses({ dispatch }, items = []) {
      for (let item of items) {
        await dispatch('updateBus', item)
      }
    },
    async removeBus({ commit }, id) {
      await Bus.remove(id)
    },
    setBus({ commit }, busData) {
      commit('setBus', busData)
    },
    setBuses({ commit }, buses) {
      commit('setBuses', buses)
    },
    setSearch({ commit }, search) {
      commit('setSearch', search)
    }
  },
  mutations: {
    setPageText(state, pageText) {
      state.pageText = pageText
    },
    setSearch(state, search) {
      state.search = search
    },
    setBuses(state, buses) {
      state.buses = keyBy(buses, 'id')
    },
    updateBus(state, busData) {
      const buses = Object.values(state.buses).map(c => {
        if (busData.id === c.id) return busData
        else return c
      })
      state.buses = keyBy(buses, 'id')
    },
    countBuses(state, count) {
      state.count = count
    },
    removeBus(state, id) {
      delete state.buses[id]
      state.buses = { ...state.buses }
    },
    setCount(state, count) {
      state.count = count
    }
  },
  getters: {
    buses: state => {
      return Object.values(state.buses)
    },
    busData: state => busId => {
      return get(state.buses, `${busId}.data`, {})
    },
    count: state => {
      return state.count
    },
    search: state => {
      return state.search
    }
  }
}
